import React from "react";
import { useNavigate } from "react-router-dom";
import { AWS_CLOUD_FRONT_URL } from "../../lib/constants";

interface MobileTopbarProps {
  isScrolled?: boolean;
}

const MobileTopbar: React.FC<MobileTopbarProps> = ({ isScrolled = false }) => {
  const navigate = useNavigate();
  const pathname = window.location.pathname.slice(1);

  return (
    <>
      <div id="topbartopscroll" className="h-[100px]"></div>
      <div
        className={`px-[5vw] py-4 sticky top-0 z-50 w-full flex justify-between transition-all duration-300 ease-in-out ${
          isScrolled ? "bg-white text-black" : "bg-customGreenColor text-white"
        }`}
      >
        <button
          className="font-helveticaLight text-2xl"
          onClick={() => navigate("/")}
        >
          <img
            src={
              isScrolled
                ? `${AWS_CLOUD_FRONT_URL}/AfroCart_Logo_Black.png`
                : `${AWS_CLOUD_FRONT_URL}/AfroCart_Logo_White.png`
            }
            className="w-[139px] h-9"
            alt="homepage_logo"
          />
        </button>
        <div className="flex gap-x-[4vw] font-helveticaMedium text-sm">
          <button
            onClick={() => navigate("/vendor-login")}
            className={`${
              pathname === "vendor-login" ? "underline" : ""
            } whitespace-nowrap`}
          >
            Login
          </button>
          <button
            onClick={() => navigate("/signup")}
            className={`${
              pathname === "signup" ? "underline" : ""
            } whitespace-nowrap`}
          >
            Join as a Vendor
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileTopbar;
